import React from "react";
import { SvgIcon } from "@mui/material";
import { ToggleableIconProps } from "@/src/types/IconProps";
import { useTheme } from "@mui/material/styles";
import { getIconColor } from "@/src/services/iconService";

const IconLicencePointsSeven = ({ active = false, sx = {} }: ToggleableIconProps) => {
  const theme = useTheme();

  return (
    <SvgIcon sx={sx} viewBox="0 0 300 300">
      <g style={{ fill: getIconColor(active, theme) }}>
        <path
          d="M29.485,287.126c-9.121-0.031-16.556-7.467-16.586-16.576V65.908c0-1.906,1.547-3.453,3.455-3.453
			c1.906,0,3.453,1.547,3.453,3.453v204.631c0.018,5.314,4.363,9.662,9.688,9.68h241.006c5.321-0.014,9.672-4.359,9.688-9.689V29.46
			c-0.018-5.316-4.367-9.666-9.697-9.678H29.496c-5.325,0.018-9.672,4.363-9.688,9.689v13.246c0,1.908-1.547,3.455-3.453,3.455
			c-1.908,0-3.455-1.547-3.455-3.455V29.46c0.03-9.117,7.459-16.551,16.563-16.586c0.008,0,0.017,0,0.022,0h241.018
			c9.126,0.021,16.566,7.457,16.598,16.576v241.088c-0.03,9.129-7.472,16.564-16.588,16.588H29.485z"
        />
        <polygon
          points="117.106,94.537 117.106,108.138 168.149,108.138 133.935,205.46 150.422,205.46 182.894,107.152
			182.894,94.537"
        />
      </g>
      <g>
        <path
          fill={theme.palette.primary.main}
          d="M266.124,269.564H33.874c-1.907,0-3.454-1.547-3.454-3.455c0-1.906,1.547-3.453,3.454-3.453H262.67V33.847
			c0-1.906,1.547-3.453,3.454-3.453s3.454,1.547,3.454,3.453v232.262C269.578,268.017,268.03,269.564,266.124,269.564z"
        />
      </g>
    </SvgIcon>
  );
};

export default IconLicencePointsSeven;
